import React from "react";
import { Card, CardBody, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import {
    ComposedChart,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,

} from "recharts";
import { setCurrencyFormat, colorArray } from '../../../utils/helpers';


export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload, isSalesKey } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
        // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
        return null
    }

    const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
        const updated = { ...item }

        if (item.name === "Amount") {
            updated.name = isSalesKey === 'amount' ? 'Total Amount' : 'Quantity';
        }
        updated.value = setCurrencyFormat(Number(item?.value).toFixed(2), isSalesKey === 'amount');

        return updated;
    });

    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
};


export default function AreaBarGraph({
    dir, showTitle, allCategories,
    dataToPlot, height, isSalesKey }) {
    const { t } = useTranslation('common');
console.log(dataToPlot)
    return (
        <Col xs={12} className="p-0">
            <Card>
                <CardBody className="p-0">
                    {showTitle ? <div className="card__title">
                        <h5 className="bold-text">{t('comparemonthlysales.compareDays')}</h5>
                    </div> : null}
                    <div dir="ltr">
                        <ResponsiveContainer height={height}>
                            <ComposedChart
                                data={dataToPlot}
                                margin={{
                                    top: 0, right: 0, left: 25, bottom: 0,
                                }}
                            >
                                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                                <XAxis dataKey="day" reversed={dir === 'rtl'} />
                                <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                                    tickFormatter={item => setCurrencyFormat(item, isSalesKey === 'amount')}
                                    width={90}
                                    allowDataOverflow
                                />
                                <Tooltip content={<CustomTooltip
                                    allCategories={allCategories} isSalesKey={isSalesKey} />}
                                />
                                <Legend />
                                <Area type="monotone" dataKey="Amount" fill="#87bdd8" stroke="#87bdd8" />
                                {allCategories && Object.keys(allCategories).map((categ, ind) => (
                                    <Bar key={categ}
                                        stackId="a"
                                        dataKey={categ.toString()}
                                        barSize={40} fill={colorArray[ind]} />
                                ))}
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
}


AreaBarGraph.propTypes = {
    dir: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    allCategories: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    isSalesKey: PropTypes.string
};

AreaBarGraph.defaultProps = {
    showTitle: true,
    isSalesKey: 'amount'
}
